import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { DnaInfoCheckBoxListModel } from './dna-info-check-box-list.model';
import { DnaInfoComboBoxService } from '../../combo-box/dna-info-combo-box/api-services/dna-info-combo-box.service';

/**
 * 商品ＤＮＡ情報ボックスリストクラス
 *
 * @export
 * @class DnaInfoCheckBoxListComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-dna-info-check-box-list',
  templateUrl: './dna-info-check-box-list.component.html',
  styleUrls: ['./dna-info-check-box-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DnaInfoCheckBoxListComponent implements OnInit, AfterViewInit, OnChanges {

  /* データ連携用リスト flexは super.data |selectedValue|CodeValue|CodeDiv|などを持つ */
  public codeList = [];

  /* FlexのUI再現のため 最後にクリックされたIDを取得 */
  public lastClickId: string = <string>'';

  /* モデルインスタンス化 */
  public dnaInfoCheckBoxListModel = new DnaInfoCheckBoxListModel();

  @ViewChild('list', { static: true }) public list: ElementRef;

  @Input() public subid: string = null;
  /* 位置調整用のパラメーター */
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number | string;

  /* そのほかパラメーター */
  @Input() public invalidCode: string = <string>'';                             // 画面に表示させないコード
  @Input() public initFocusItem: string = <string>'';                           // ロード完了後フォーカスを移動させるid
  @Input() forcedEnabledMode: string = null;

  /**
   * コンストラクタ
   *
   * @param {DnaInfoComboBoxService} dnaInfoComboBoxService
   * @memberof DnaInfoCheckBoxListComponent
   */
  constructor(
    private dnaInfoComboBoxService: DnaInfoComboBoxService,
    public elementRef: ElementRef,
    ) { }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof DnaInfoCheckBoxListComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'invalidCode':
          // 先頭空白表示フラグ
          this.dnaInfoCheckBoxListModel.invalidCode = changes.invalidCode.currentValue;
          break;
      }
    });
  }

  /**
   * 初期処理
   *
   * @memberof DnaInfoCheckBoxListComponent
   */
  ngOnInit(): void {
    // 自身をモデルに入れる
    this.dnaInfoCheckBoxListModel.codeListUI = this;
    this.list.nativeElement.setAttribute('id', this.subid + '_sub');
    this.list.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof DnaInfoCheckBoxListComponent
   */
  ngAfterViewInit(): void {
    // データ取得
    this.dnaInfoComboBoxService.execute(this.dnaInfoCheckBoxListModel, null);
  }


  /**
   * バインドの更新
   *
   * @param {string} itemCode // UI用最後にクリックされた箇所を取得する
   * @memberof DnaInfoCheckBoxListComponent
   */
  public onChange(itemCode: string): void {
    // クリックされたIDをlastClickIdに保持し、html側のIDと同じ場合色付けする
    this.lastClickId = itemCode;

    // 画面のチェック状態を変数に保持 自身のListに反映させる
    this.codeList = this.dnaInfoCheckBoxListModel.codeList;
  }

  /**
   * 選択コードNameを切り替える
   * codeValueのコードをチェックONにして、それ以外のコードをチェックOFFにする
   *
   * @param {string} setDnaDiv // コード値
   * @memberof DnaInfoCheckBoxListComponent
   */
  public setCodeValue(codeValue: string): void {
    this.dnaInfoCheckBoxListModel.setDnaDiv = codeValue;

    // ロード完了の場合
    if (this.dnaInfoCheckBoxListModel.completeUpdateCodeList) {
      this.updateSelectedDnaDiv();
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @memberof DnaInfoCheckBoxListComponent
   */
  public updateSelectedDnaDiv(): void {
    if (this.dnaInfoCheckBoxListModel.setDnaDiv != null) {
      let codeList = [];
      codeList = this.dnaInfoCheckBoxListModel.codeList;
      for (let i: number = <number>0; i < codeList.length; i++) {
        if (codeList[i].DnaDiv === this.dnaInfoCheckBoxListModel.setDnaDiv) {
          this.dnaInfoCheckBoxListModel.codeList[i].selectedValue = [true];
        } else {
          this.dnaInfoCheckBoxListModel.codeList[i].selectedValue = [false];
        }
      }
    }

    // バインドフィールドを更新
    this.onChange(null);
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @param {string} code
   * @param {boolean} chk
   * @memberof DnaInfoCheckBoxListComponent
   */
  public updateCheckCodeValue(code: string, chk: boolean): void {
    if (code === null) {
      let codeList = [];
      codeList = this.dnaInfoCheckBoxListModel.codeList;

      for (let i: any = 0; i < codeList.length; i++) {
        this.codeList[i].selectedValue = [chk];
      }
    } else {
      let codeList = [];
      codeList = this.codeList;
      for (let i: any = 0; i < codeList.length; i++) {
        if (codeList[i].CodeValue.trim() === code) {
          this.codeList[i].selectedValue = [chk];
        }
      }
    }
  }

  /**
   * コード更新完了 渡されたID属性へ遷移する
   *
   * @memberof DnaInfoCheckBoxListComponent
   */
  public updateListComplete(): void {
    if (this.initFocusItem != null) {
      document.getElementById(this.initFocusItem).focus();
    }
  }

}
